export default __webpack_public_path__ + "static/media/workingStepLogo.5f42eb06.svg";